export enum StudentDetailsActionTypes {
    API_RESPONSE_SUCCESS = "@@student_details/API_RESPONSE_SUCCESS",
    API_RESPONSE_ERROR = "@@student_details/API_RESPONSE_ERROR",
    SAVE_PRELIMINARY_DETAILS = "@@student_details/SAVE_PRELIMINARY_DETAILS",
    SAVE_SECURED_DETAILS = "@@student_details/SAVE_SECURED_DETAILS",
    SAVE_UN_SECURED_DETAILS = "@@student_details/SAVE_UN_SECURED_DETAILS",
    CHECK_LOAN_TYPE = "@@student_details/CHECK_LOAN_TYPE",
    SAVE_LOAN_TYPE = "@@student_details/SAVE_LOAN_TYPE",
    CLEAR_LOAN_TYPE_STATE = "@@student_details/CLEAR_LOAN_TYPE_STATE",
  }
  